import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.magma = bracketIndenting()
